import { render, staticRenderFns } from "./CustomerMenu.vue?vue&type=template&id=21746db5&scoped=true&"
import script from "./CustomerMenu.vue?vue&type=script&lang=js&"
export * from "./CustomerMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMenu.vue?vue&type=style&index=0&id=21746db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21746db5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
